module.exports = __webpack_public_path__ + "img/UG.3f83778d.png";